export function setThemeColorFromTunnelData(tunnelData) {
  document.documentElement.style.setProperty("--brandColor", tunnelData?.brandColor)
  document.documentElement.style.setProperty("--brandDarkColor", tunnelData?.brandDarkColor)
  document.documentElement.style.setProperty("--brandMediumColor", tunnelData?.brandMediumColor)
}

// tunnelData.brandDarkColor = brandDarkColor;
// tunnelData.brandColor = brandColor;
// tunnelData.brandMediumColor = brandMediumColor;
// tunnelData.brandLightColor = brandLightColor;
// tunnelData.validationDarkColor = validationDarkColor;
// tunnelData.validationColor = validationColor;
// tunnelData.validationMediumColor = validationMediumColor;
// tunnelData.chooseServiceButtonClicked = "#02A571"
// tunnelData.checkServiceColColor = "#02A571"
// tunnelData.checkServiceBasketColor = "#02A571"
